import { useState } from "react";
const getTabIndex = (activeIndex, itemIndex) => {
  const isSelected = activeIndex === itemIndex;
  const isFirstItem = itemIndex === 0;
  if (activeIndex) {
    return isSelected ? 0 : -1;
  }
  return isFirstItem ? 0 : -1;
};
const useFocusManager = ({
  autoFocusFirstElement = false,
  containerRole = "list",
  itemRole = "listitem",
  orientation = "horizontal"
} = {}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const handleKeyDown = (event) => {
    const targetElement = event.target;
    const role = targetElement.getAttribute("role");
    if (role !== itemRole) {
      return;
    }
    const previousKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
    const nextKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
    let newFocusTarget = null;
    switch (event.key) {
      case previousKey:
        newFocusTarget = targetElement.previousElementSibling ?? targetElement.parentElement?.lastElementChild;
        break;
      case nextKey:
        newFocusTarget = targetElement.nextElementSibling ?? targetElement.parentElement?.firstElementChild;
        break;
      case "Home":
        newFocusTarget = targetElement.parentElement?.firstElementChild;
        break;
      case "End":
        newFocusTarget = targetElement.parentElement?.lastElementChild;
        break;
      default:
        break;
    }
    if (newFocusTarget != null) {
      newFocusTarget.focus();
      event.preventDefault();
    }
  };
  return {
    containerProps: {
      "aria-orientation": orientation,
      onBlur: () => {
        setActiveIndex(0);
      },
      onKeyDown: handleKeyDown,
      role: containerRole,
      tabIndex: -1
    },
    getItemProps: (itemIndex) => ({
      "aria-selected": activeIndex === itemIndex,
      autoFocus: Boolean(autoFocusFirstElement) && itemIndex === 0,
      onFocus: () => {
        setActiveIndex(itemIndex);
      },
      role: itemRole,
      tabIndex: getTabIndex(activeIndex, itemIndex)
    }),
    setActiveIndex
  };
};
export {
  useFocusManager
};
